<script>
    export let textBlocks;
</script>

<article class="article">
<div class="article-content">
    {#each textBlocks as block}
        <span class="anim-wrapper">
            {#if block.type === 'paragraph'}
                <p>{ @html block.data.text }</p>
            {:else if block.type === 'header'}
                {#if block.data.level === 1 || block.data.level === 2}
                    <h2>{ @html block.data.text }</h2>
                {:else if block.data.level === 3}
                    <h3>{ @html block.data.text }</h3>
                {:else if block.data.level === 4}
                    <h4>{ @html block.data.text }</h4>
                {:else if block.data.level === 5}
                    <h5>{ @html block.data.text }</h5>
                {:else if block.data.level === 6}
                    <h6>{ @html block.data.text }</h6>
                {/if}
            {:else if block.type === 'delimiter'}
                <hr/>
            {:else if block.type === 'list'}
                <ul>
                    {#each block.data.items as item}
                    <span class="anim-wrapper">
                        <li>
                            <p>{ @html item }</p>
                        </li>
                    </span>
                    {/each}
                </ul>
            {/if}
        </span>
    {/each}
</div>
</article>